import { createTheme } from '@mui/material/styles';

/** Default fill for `<TableCell>` headers without an explicit tint (checkbox, actions, etc.). */
export const TABLE_HEADER_NEUTRAL_BG = '#f0f2f4';

// Create a custom Material-UI theme
export const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#dc004e',
      light: '#f73378',
      dark: '#9a0036',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: TABLE_HEADER_NEUTRAL_BG,
        },
      },
    },
    /** Only show the sort arrow on the column currently driving the sort. */
    MuiTableSortLabel: {
      defaultProps: {
        hideSortIcon: true,
      },
    },
  },
});

